import { createBrowserHistory, History, BrowserHistoryBuildOptions } from 'history';

let browserHistory: History | null = null;

const getOrCreateHistory = (options?: BrowserHistoryBuildOptions): History => {
    if (browserHistory !== null) {
        return browserHistory;
    }

    browserHistory = createBrowserHistory({ ...options });
    return browserHistory;
};

export default getOrCreateHistory;
